import config from "@/config/filterBar";
export default {
    props: {
        filterName: {
            type: String,
            default: ""
        },
        data: {
            type: Object,
            default: ()=>{}
        }
    },
    data () {
        return {
            loading: false,
            myFilter: []
        };
    },
    watch: {
        data: {
            handler () {
                this.myFilter = this.data;
            },
            deep: true
        }
    },
    mounted () {
        this.myFilter = this.data;
        this.getMyfilter();
    },
    methods: {
        //选择常用过滤
        selectMyfilter (item) {
            this.$emit('selectMyfilter', item);
        },
        //删除常用过滤
        async closeMyfilter (item, index) {
            try {
                var del = await config.delMy(this.filterName);
            } catch (error) {
                return false;
            }
            if (!del) {
                return false;
            }
            this.myFilter.splice(index, 1);
            this.$message.success('删除常用成功');
        },
        //远程获取我的常用
        async getMyfilter () {
            this.loading = true;
            try {
                this.myFilter = await config.getMy(this.filterName);
            } catch (error) {
                return false;
            }
            this.loading = false;
        }
    }
};
